//@flow
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import config from '../../config';
import SelectCountry from './SelectCountry';
import { setIddCountry } from '../../modules/International/IDD/actions';
import { getIddZoneCountries } from '../../lib/country-utils';

import type { DispatchProps, StateProps } from './SelectCountry';
import type { StateType } from '../../modules/reducers';
import Navigation from '../../lib/navigation';

const initialCountries = getIddZoneCountries(config.iddCountries);

const mapStateToProps = (state: StateType): StateProps => ({
  initialCountries,
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  selectCountry: country => {
    dispatch(setIddCountry(country));
    !!country.iddZone
      ? Navigation.dispatch(CommonActions.navigate({ name: 'chooseInternationalOptions' }))
      : Navigation.dispatch(CommonActions.navigate({ name: 'noInternationalOffer' }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCountry);
